import type { HTMLAttributes } from 'react';

import { getTovIconClass, type TovIconName } from '../../contracts/iconography';
import { cn } from '../../lib/utils';

export interface TovIconProps extends HTMLAttributes<HTMLSpanElement> {
  name: TovIconName;
  label?: string;
  directional?: boolean;
}

export function TovIcon({
  className,
  directional = false,
  name,
  label,
  ...props
}: TovIconProps) {
  return (
    <span
      aria-hidden={label ? undefined : 'true'}
      aria-label={label}
      className={cn(
        'tov-icon',
        directional && 'tov-icon--directional',
        getTovIconClass(name),
        className,
      )}
      {...props}
    />
  );
}
